<template>
  <b-card class="mb-4" no-header>
    <b-row>
      <b-col cols="12">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <b-button-group class="add-button-group">
            <b-btn variant="primary" to="/kode-rekening/create"
              ><font-awesome-icon icon="plus" /> Tambah Data</b-btn
            >
          </b-button-group>
        </div>
      </b-col>
      <b-col cols="12" class="mb-3">
        <b-form @submit.prevent="doFilter">
          <b-row class="filter-row">
            <b-col cols="6" md="6">
              <form-group-input
                ref="filter-name"
                type="text"
                v-model="filter.name"
                placeholder=""
                :need-label="true"
                label="Rincian Objek"
                id="filter-name"
              />
            </b-col>
            <b-col cols="6" md="2">
              <label class="form-label">&nbsp;</label><br />
              <b-btn type="submit" class="btn-in-form" variant="primary">
                <font-awesome-icon icon="search" /><span>Cari</span>
              </b-btn>
              <b-btn
                type="button"
                @click.prevent="clearForm"
                variant="secondary"
                class="btn-in-form ml-2"
              >
                <font-awesome-icon icon="broom" /><span>Clear</span>
              </b-btn>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
    <paginated-table
      ref="dataTable"
      :delete-reason="false"
      :can-delete="true"
      :can-edit="true"
      :data-url="apiUrl.school"
      :data-columns="columns"
      :dataParams="dataParams"
      :defaultDataParams="this.filter"
    >
      <template slot="content_district_id" slot-scope="defaultSlotScope">
        <span style="text-transform: capitalize">{{
          defaultSlotScope.colData.district.name
        }}</span>
      </template>
    </paginated-table>
  </b-card>
</template>

<script>
import { objectToOptions, classicObjectToOptions } from "@/_helpers";
import paginatedTable from "@/components/PaginatedTable.vue";
import formGroupInput from "@/components/FormGroupInput.vue";
import Rekening from "@/models/Rekening.js";

const rekeningModel = new Rekening();

export default {
  components: {
    formGroupInput,
    paginatedTable,
  },
  data() {
    return {
      isLoading: false,
      apiUrl: {
        school: rekeningModel.endpoint,
      },
      columns: [
        {
          prop: "code",
          label: "Kode",
          sortable: true,
          resizable: true,
          minWidth: 200,
        },
        {
          prop: "name",
          label: "Rincian Objek",
          sortable: true,
          resizable: true,
          minWidth: 200,
        },
      ],
      list: {
      },
      filter: {
        parent_only: 1,
        name: this.$route.query.name ?? null
      },
      dataParams: [
        //'list_item',
        'name',
        'parent_only'
      ],
    };
  },
  // beforeMount() {
  //   this.$router
  //     .push({
  //       query: {
  //         ...this.$route.query,
  //         ...{ 'list_item': 1, 'parent_only': 1 },
  //       },
  //     })
  //     .catch((err) => {});
  // },
  async mounted() {
  },
  watch: {
  },
  methods: {
    clearForm() {
      this.$nextTick(() => {
        this.filter.name = null
        setTimeout(() => {
          this.doFilter();
        }, 100);
      });
    },
    doFilter() {
      this.$refs.dataTable.doFilter(this.filter);
    },

    // doExport() {
    //   if (this.isLoading) {
    //     return false;
    //   }
    //   this.isLoading = true;
    //   const filterArray = [];
    //   Object.keys(this.filter).forEach((key) => {
    //     if (this.filter[key]) {
    //       filterArray.push(key + "=" + this.filter[key]);
    //     }
    //   });
    //   filterArray.push("csv=1");

    //   this.$http
    //     .get(userModel.getEndpoint() + "?" + filterArray.join("&"))
    //     .then((response) => {
    //       const a = document.createElement("a");

    //       const blob = new Blob([response.data], { type: "octet/stream" });
    //       a.href = window.URL.createObjectURL(blob);

    //       a.download = "data_admin.csv";
    //       a.click();
    //       this.isLoading = false;
    //     })
    //     .catch((error) => {
    //       this.$store.dispatch("notification/error", error);
    //       this.isLoading = false;
    //     });
    // },
  },
};
</script>